import React, { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Context } from "../../../utils/context";

const thumbStyle = {
  width: "90px",
  height: "90px",
  objectFit: "cover",
  borderRadius: "6px",
  border: "1px solid #ced4da",
};

// File picker + preview for one answer's image.
// file: newly picked File, existingImage: saved image path (edit only)
const AnswerImage = ({ inputProps, file, existingImage, onRemoveExisting }) => {
  const { IMG_URL } = useContext(Context);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return;
    }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const src = preview || (existingImage ? IMG_URL + existingImage : null);

  return (
    <div className="d-flex align-items-center gap-2 mt-2">
      <Form.Control type="file" accept="image/*" size="sm" {...inputProps} />
      {src && <img src={src} alt="Answer" style={thumbStyle} />}
      {!preview && existingImage && onRemoveExisting && (
        <Button
          variant="link"
          size="sm"
          className="text-danger p-0"
          onClick={onRemoveExisting}
        >
          Remove
        </Button>
      )}
    </div>
  );
};

export default AnswerImage;
